<template>
  <div class="">
    <nut-navbar
      :left-show="false"
      :title="$t('envelopes.h1')"
      fixed=true
      class="mb0 nav-icon-right nut-navbar--fixed"
    >
    <template #left>
      <i class="nutui-iconfont nut-icon nut-icon-left" @click="backClick"></i>
    </template>
    </nut-navbar>

    <div class="pt50">
      <div class="csls">
        <div class="csls-item">
          <h4>{{ dataList.title }}</h4>
          <p>{{ dataList.sendTime }}</p>
          <div class="bd"><pre style="white-space:pre-wrap;word-wrap:break-word"> {{ dataList.content }}</pre></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
export default {
  data() {
    return {
      id:'',
      dataList:{},
      content:''
    }
  },
  methods: {
    gettingData() {
      var data = this.$route.query.details
      this.id = data
      axios({
        url: "/api/system/letter/detail",
        method: "get",
        params: { id: this.id },
      }).then((res) => {
        this.dataList = res.data.data;
        this.content = this.dataList.content.replace(/\r/ig,'').replace(/\n/ig,'<br/>')
      });
    }
  },
  watch: {
    //'$route': 'gettingData'
  },
  created() {
    this.gettingData()
  },
  setup() {
    const state = reactive({});
    const router = useRouter();
    const methods = {
      backClick() {
        router.push({
          name: "envelopesCenter",
        });
      },
    };
    return {
      ...toRefs(state),
      ...methods,
    };
  }
};
</script>

<style scoped>
.csls{ padding: 10px; margin:10px; border: 1px solid #eee;border-radius: 5px; background: #f5f5f5;}
.csls-item {
  margin-bottom: 10px;
  padding-bottom: 10px;
  
}
.csls-item h4 {
  margin: 5px 0;
  line-height: 24px;
  border-bottom: 1px solid #eee;
}
.csls-item p {
  line-height: 24px;
  padding: 0;
  margin: 0;
  color: #999;
}
.csls-item .tx-right-r {
  float: right;
  line-height: 22px;
  background: #fff3f3;
  color: #cf0505;
  border-radius: 15px;
  font-size: 10px;
  padding: 0px 10px;
}
.csls-item .tx-right-g {
  float: right;
  line-height: 22px;
  background: #f1ffe8;
  color: #5c9834;
  border-radius: 15px;
  font-size: 10px;
  padding: 0px 10px;
}
.csls-answer {
  background: #f1ffe8;
  padding: 10px;
  color: #5c9834;
  margin-top: 10px;
  border-radius: 0 15px 15px 15px;
  border: 1px solid #d2e8c3;
}


</style>